import { render, staticRenderFns } from "./International5.vue?vue&type=template&id=5231b47b&scoped=true"
import script from "./International5.vue?vue&type=script&lang=js"
export * from "./International5.vue?vue&type=script&lang=js"
import style0 from "./International5.vue?vue&type=style&index=0&id=5231b47b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231b47b",
  null
  
)

export default component.exports